export default function LoadingScreen({ hidden = false }: { hidden?: boolean }) {
  return (
    <div className={'loading-screen' + (hidden ? ' hidden' : '')}>
      <div className="loading-logo">Hensley Heritage</div>
      <div className="loading-sub">Loading shared batch tracker…</div>
      <div className="loading-bar">
        <div className="loading-fill" />
      </div>
    </div>
  );
}
